"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require("bluebird");

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _languageHandler = require("../../../languageHandler");

var _MatrixClientPeg = require("../../../MatrixClientPeg");

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _Field = require("../elements/Field");

var _Field2 = _interopRequireDefault(_Field);

var _AccessibleButton = require("../elements/AccessibleButton");

var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _matrixJsSdk = require("matrix-js-sdk");

var _HostingLink = require("../../../utils/HostingLink");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var ProfileSettings = function (_React$Component) {
    (0, _inherits3.default)(ProfileSettings, _React$Component);

    function ProfileSettings() {
        (0, _classCallCheck3.default)(this, ProfileSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ProfileSettings.__proto__ || (0, _getPrototypeOf2.default)(ProfileSettings)).call(this));

        _initialiseProps.call(_this);

        var client = _MatrixClientPeg2.default.get();
        var user = client.getUser(client.getUserId());
        if (!user) {
            // XXX: We shouldn't have to do this.
            // There seems to be a condition where the User object won't exist until a room
            // exists on the account. To work around this, we'll just create a temporary User
            // and use that.
            console.warn("User object not found - creating one for ProfileSettings");
            user = new _matrixJsSdk.User(client.getUserId());
        }
        var avatarUrl = user.avatarUrl;
        if (avatarUrl) avatarUrl = client.mxcUrlToHttp(avatarUrl, 96, 96, 'crop', false);
        _this.state = {
            userId: user.userId,
            originalDisplayName: user.displayName,
            displayName: user.displayName,
            originalAvatarUrl: avatarUrl,
            avatarUrl: avatarUrl,
            avatarFile: null,
            enableProfileSave: false
        };
        return _this;
    }

    (0, _createClass3.default)(ProfileSettings, [{
        key: "render",
        value: function render() {
            // TODO: Why is rendering a box with an overlay so complicated? Can the DOM be reduced?

            var showOverlayAnyways = true;
            var avatarElement = _react2.default.createElement("div", { className: "mx_ProfileSettings_avatarPlaceholder" });
            if (this.state.avatarUrl) {
                showOverlayAnyways = false;
                avatarElement = _react2.default.createElement("img", { src: this.state.avatarUrl,
                    alt: (0, _languageHandler._t)("Profile picture") });
            }

            var avatarOverlayClasses = (0, _classnames2.default)({
                "mx_ProfileSettings_avatarOverlay": true,
                "mx_ProfileSettings_avatarOverlay_show": showOverlayAnyways
            });
            var avatarHoverElement = _react2.default.createElement(
                "div",
                { className: avatarOverlayClasses, onClick: this._uploadAvatar },
                _react2.default.createElement(
                    "span",
                    { className: "mx_ProfileSettings_avatarOverlayText" },
                    (0, _languageHandler._t)("Upload profile picture")
                ),
                _react2.default.createElement(
                    "div",
                    { className: "mx_ProfileSettings_avatarOverlayImgContainer" },
                    _react2.default.createElement("div", { className: "mx_ProfileSettings_avatarOverlayImg" })
                )
            );

            var hostingSignupLink = (0, _HostingLink.getHostingLink)('user-settings');
            var hostingSignup = null;
            if (hostingSignupLink) {
                hostingSignup = _react2.default.createElement(
                    "span",
                    { className: "mx_ProfileSettings_hostingSignup" },
                    (0, _languageHandler._t)("<a>Upgrade</a> to your own domain", {}, {
                        a: function a(sub) {
                            return _react2.default.createElement(
                                "a",
                                { href: hostingSignupLink, target: "_blank", rel: "noopener" },
                                sub
                            );
                        }
                    }),
                    _react2.default.createElement(
                        "a",
                        { href: hostingSignupLink, target: "_blank", rel: "noopener" },
                        _react2.default.createElement("img", { src: require("../../../../res/img/external-link.svg"), width: "11", height: "10", alt: "" })
                    )
                );
            }

            return _react2.default.createElement(
                "form",
                { onSubmit: this._saveProfile, autoComplete: false, noValidate: true },
                _react2.default.createElement("input", { type: "file", ref: "avatarUpload", className: "mx_ProfileSettings_avatarUpload",
                    onChange: this._onAvatarChanged, accept: "image/*" }),
                _react2.default.createElement(
                    "div",
                    { className: "mx_ProfileSettings_profile" },
                    _react2.default.createElement(
                        "div",
                        { className: "mx_ProfileSettings_controls" },
                        _react2.default.createElement(
                            "p",
                            null,
                            this.state.userId,
                            hostingSignup
                        ),
                        _react2.default.createElement(_Field2.default, { id: "profileDisplayName", label: (0, _languageHandler._t)("Display Name"),
                            type: "text", value: this.state.displayName, autoComplete: "off",
                            onChange: this._onDisplayNameChanged })
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "mx_ProfileSettings_avatar" },
                        avatarElement,
                        avatarHoverElement
                    )
                ),
                _react2.default.createElement(
                    _AccessibleButton2.default,
                    { onClick: this._saveProfile, kind: "primary",
                        disabled: !this.state.enableProfileSave },
                    (0, _languageHandler._t)("Save")
                )
            );
        }
    }]);
    return ProfileSettings;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this._uploadAvatar = function (e) {
        e.stopPropagation();
        e.preventDefault();

        _this2.refs.avatarUpload.click();
    };

    this._saveProfile = function () {
        var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
            var client, newState, uri;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            e.stopPropagation();
                            e.preventDefault();

                            if (_this2.state.enableProfileSave) {
                                _context.next = 4;
                                break;
                            }

                            return _context.abrupt("return");

                        case 4:
                            _this2.setState({ enableProfileSave: false });

                            client = _MatrixClientPeg2.default.get();
                            newState = {};

                            // TODO: What do we do about errors?

                            if (!(_this2.state.originalDisplayName !== _this2.state.displayName)) {
                                _context.next = 11;
                                break;
                            }

                            _context.next = 10;
                            return (0, _bluebird.resolve)(client.setDisplayName(_this2.state.displayName));

                        case 10:
                            newState.originalDisplayName = _this2.state.displayName;

                        case 11:
                            if (!_this2.state.avatarFile) {
                                _context.next = 20;
                                break;
                            }

                            _context.next = 14;
                            return (0, _bluebird.resolve)(client.uploadContent(_this2.state.avatarFile));

                        case 14:
                            uri = _context.sent;
                            _context.next = 17;
                            return (0, _bluebird.resolve)(client.setAvatarUrl(uri));

                        case 17:
                            newState.avatarUrl = client.mxcUrlToHttp(uri, 96, 96, 'crop', false);
                            newState.originalAvatarUrl = newState.avatarUrl;
                            newState.avatarFile = null;

                        case 20:

                            _this2.setState(newState);

                        case 21:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();

    this._onDisplayNameChanged = function (e) {
        _this2.setState({
            displayName: e.target.value,
            enableProfileSave: true
        });
    };

    this._onAvatarChanged = function (e) {
        if (!e.target.files || !e.target.files.length) {
            _this2.setState({
                avatarUrl: _this2.state.originalAvatarUrl,
                avatarFile: null,
                enableProfileSave: false
            });
            return;
        }

        var file = e.target.files[0];
        var reader = new FileReader();
        reader.onload = function (ev) {
            _this2.setState({
                avatarUrl: ev.target.result,
                avatarFile: file,
                enableProfileSave: true
            });
        };
        reader.readAsDataURL(file);
    };
};

exports.default = ProfileSettings;
module.exports = exports["default"];
//# sourceMappingURL=ProfileSettings.js.map